// extracted by mini-css-extract-plugin
export var container = "_b6-0";
export var icon = "_b6-1";
export var text = "_b6-2";